import { string } from 'yup';
import type { StringSchema } from 'yup';

interface TextValidatorInterface {
  fieldName: string;
  required?: boolean;
  minLength?: number;
  isInnField?: boolean;
  readableFieldName?: string;
  length?: number;
  formatMessage?: string;
  innLength?: number;
}

export const innKppValidator = ({
  fieldName,
  required = true,
  minLength,
  isInnField,
  readableFieldName,
  length,
  innLength,
  formatMessage,
}: TextValidatorInterface): StringSchema<
  string | null | undefined,
  Record<string, unknown>,
  string | null | undefined
> => {
  const readableName = readableFieldName ? `"${readableFieldName}" ` : '';
  return string()
    .nullable()
    .test(fieldName, `Поле ${readableName}должно быть заполнено`, (value) => !(!value && required))
    .test(fieldName, `Поле ${readableName}не может начинаться с пробела`, (value) => !(value && value.match(/^\s+/)))
    .test(fieldName, `Поле ${readableName}не должно оканчиваться на пробел`, (value) => !(value && value.match(/\s+$/)))
    .test(
      fieldName,
      `Поле (или ключ поля) ${readableName} должно содержать определенное количество символов (${length})`,
      (value) => length === undefined || !(value && typeof value === 'string' && value.trim().length !== length),
    )
    .test(
      fieldName,
      `Минимальное количество символов у поля ${readableName}- ${minLength}`,
      (value) => minLength === undefined || !(!!value && typeof value === 'string' && value.trim().length < minLength),
    )
    .test(
      fieldName,
      `Длина поля ${readableName}должна соответствовать ${innLength || '10 или 12'} символам`,
      (value) =>
        (isInnField || innLength) && !!value
          ? typeof value === 'string' &&
            (innLength ? value.length === innLength : value.length === 10 || value.length === 12)
          : true,
    )
    .test(fieldName, `Длина поля должна соответствовать 9 символам`, (value) =>
      !isInnField && !innLength && !!value ? typeof value === 'string' && value.length === 9 : true,
    )
    .test(fieldName, formatMessage || `Поле ${readableName}должно соответствовать формату`, (value) =>
      // Минимум 9 символов (КПП) и вначале не может быть 2 нуля подряд
      !!value ? !!value.match(/^\d[1-9]\d{7}(\d+)?$/) || !!value.match(/^[1-9]\d{8}(\d+)?$/) : true,
    );
};
